import { cva } from 'class-variance-authority';

export const variant = {
  solid: 'bg-muted',
  dashed: 'border-muted bg-transparent border-dashed',
};

export const mode = {
  standalone: '',
  flex: 'flex-1',
};

export const separatorVariants = cva('shrink-0', {
  variants: {
    variant,
    mode,
  },
  defaultVariants: {
    variant: 'solid',
    mode: 'standalone',
  },
  compoundVariants: [
    {
      variant: 'solid',
      mode: 'standalone',
      class:
        'data-[orientation=horizontal]:h-[2px] data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch',
    },
    {
      variant: 'solid',
      mode: 'flex',
      class: 'h-[2px]',
    },
    {
      variant: 'dashed',
      mode: 'standalone',
      class:
        'data-[orientation=horizontal]:h-0 data-[orientation=horizontal]:w-full data-[orientation=horizontal]:border-t-2 data-[orientation=vertical]:w-0 data-[orientation=vertical]:self-stretch data-[orientation=vertical]:border-l-2',
    },
    {
      variant: 'dashed',
      mode: 'flex',
      class: 'h-0 border-t-2',
    },
  ],
});

export const separatorLabelVariants = cva(
  'text-muted-foreground text-sm font-medium tracking-wider uppercase'
);

export const separatorWrapperVariants = cva('flex w-full items-center gap-3');
